/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';

export interface DeleteOneBuchung$Json$Params {

/**
 * ID der Buchung die gelöscht werden soll
 */
  buchungsId: string;
}

export function deleteOneBuchung$Json(http: HttpClient, rootUrl: string, params: DeleteOneBuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, deleteOneBuchung$Json.PATH, 'delete');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

deleteOneBuchung$Json.PATH = '/v1/buchungen/{buchungsId}';
